import React from 'react';
import { get } from 'lodash';
import FormFields from '../form-fields/FormFields';
import FieldGroup from '../form-fields/FieldGroup';
import { CreateFormProps } from '../../../../lib/types/types';

interface FieldProp {
	type: string;
	path: string;
	[key: string]: any; // Allows additional props to be passed
}

interface FieldGroupProp {
	userProps?: string;
	fields?: FieldProp[];
}

const CreateForm: React.FC<CreateFormProps> = (props) => {
	const { formStruc, formValues, formErrors, updateFormValuesFunc, readOnly, printMode } = props;
	const formComponents = (
		<>
			{(formStruc || []).map((eachFieldRow: FieldGroupProp, i: number) => (
				<FieldGroup key={i} userProps={get(eachFieldRow, 'userProps', '')} printMode={printMode ? printMode : false} eachFieldProps={eachFieldRow}>
					{get(eachFieldRow, 'fields', []).map((fieldProp: FieldProp, index: number) => (
						<FormFields
							key={index}
							formValues={formValues}
							formErrors={formErrors}
							printMode={printMode ? printMode : false}
							onChange={updateFormValuesFunc}
							readOnly={readOnly ? readOnly : false}
							api={get(props, 'api', '')}
							{...fieldProp}
						/>
					))}
				</FieldGroup>
			))}
		</>
	);
	return formComponents;
};

export default CreateForm;
